import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@/config/constants";
import { useAppAccess } from "@/hooks/useAppAccess";
import {
  canAccessLocacoesModule,
  canAccessSolicitacaoPagamentoModule,
  type AppAccessKey,
} from "@/lib/appAccess";
import { useAuth } from "@/hooks/useAuth";

export function ModuleAccess({
  module,
  modules,
  solicitacaoPagamentoModule,
  locacoesModule,
  children,
}: {
  module?: AppAccessKey;
  modules?: AppAccessKey[];
  /** Rota do módulo Solicitação de Pagamento — mesma regra de menu e permissões. */
  solicitacaoPagamentoModule?: boolean;
  /** Rota do módulo Semog Locações — inclui operadores vinculados a contratos. */
  locacoesModule?: boolean;
  children: ReactNode;
}) {
  const { can } = useAppAccess();
  const { user } = useAuth();

  if (solicitacaoPagamentoModule) {
    if (!canAccessSolicitacaoPagamentoModule(can)) {
      return <Navigate to={ROUTES.HOME} replace />;
    }
    return <>{children}</>;
  }

  if (locacoesModule) {
    if (!canAccessLocacoesModule(can, user?.locacoesOperador)) {
      return <Navigate to={ROUTES.HOME} replace />;
    }
    return <>{children}</>;
  }

  const keys = modules ?? (module != null ? [module] : []);
  if (keys.length === 0 || !keys.some((k) => can(k))) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return <>{children}</>;
}
